import React from 'react';
import { Grid } from '@material-ui/core';
import { LongArrowRight, palette, Typography } from '@dev/ee-components';
import styled from 'styled-components';

import { ContentBoxProps } from '../../SubjectAndContentInterface';

const IconWrapper = styled.div`
    height: 240px;
    border: 1px solid ${palette.gray[3]};
    border-radius: 20px;

    svg {
        width: 100%;
    }
`;

const TitleWrapper = styled.div`
    display: inline-flex;
    margin-top: 32px;
    margin-left: 16px;
    margin-bottom: 10px;
`;

const ContentBoxWrapper = styled.div`
    cursor: pointer;

    &:hover {
        & > div:first-child {
            box-shadow: 2px 3px 10px #6665b93d;
        }
    }
`;

export const ContentBox = (props: ContentBoxProps): JSX.Element => {
    const { icon, title, description, onBoxClick, id } = props;

    return (
        <Grid item xs>
            <ContentBoxWrapper id={id} onClick={onBoxClick}>
                <IconWrapper>{icon}</IconWrapper>
                <TitleWrapper>
                    <Typography variant="h2">{title}</Typography>
                    <LongArrowRight />
                </TitleWrapper>
                <Typography variant="body1" style={{ marginLeft: 16 }}>
                    {description}
                </Typography>
            </ContentBoxWrapper>
        </Grid>
    );
};
